import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

import Login from './components/Login/login';
import Dashboard from './components/Dashboard/Dashboard';
import Home1 from './components/Dashboard/Home';
import Images from './components/Dashboard/Images';

import Links from './components/Dashboard/Links';
import Directory from './components/Dashboard/Directory';

import { ToastContainer } from 'react-toastify';
import Result from './components/Dashboard/Result';
import Advertisement from './components/Dashboard/Advertisement';
import Tender from './components/Dashboard/Tender';
import PublicNotice from './components/Dashboard/PublicNotice';

import Notification from './components/Dashboard/Notification';

// Scroll to top on route change
const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
};

// Main App Navigation with routes
const AppNav = () => {
  const location = useLocation();

  const hideLayoutRoutes = [
    "/dashboard",
    "/dashboard/home",
    "/dashboard/upload-images",
    "/dashboard/upload-notifications",
    "/dashboard/upload-sale-rates",
    "/dashboard/upload-directory",
    "/dashboard/upload-result",
    "/dashboard/upload-advertisement",
    "/dashboard/upload-tender",
    "/dashboard/upload-notice"

  ];

  const hideFooterRoutes = [
    ...hideLayoutRoutes,
    "/login",
    "/"
  ];

  const hideLayout = hideLayoutRoutes.includes(location.pathname);
  const hideFooter = hideFooterRoutes.includes(location.pathname);

  return (
    <>
      <ScrollToTop />

      {/* Layout conditional rendering if needed */}
      {!hideLayout && <header>{/* Add Header here if needed */}</header>}

      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />}>
          <Route path="home" element={<Home1 />} />
          <Route path="upload-images" element={<Images />} />
          <Route path="upload-advertisement" element={<Advertisement />} />
          <Route path="upload-sale-rates" element={<Links />} />
          <Route path="upload-directory" element={<Directory />} />
          <Route path="upload-result" element={<Result />} />
          <Route path="upload-tender" element={<Tender />} />
          <Route path="upload-notification" element={<Notification />} />
          <Route path="upload-notice" element={<PublicNotice />} />
        </Route>
      </Routes>

      {/* Footer conditional rendering if needed */}
      {!hideFooter && <footer>{/* Add Footer here if needed */}</footer>}

      <ToastContainer position="top-center" hideProgressBar={true} autoClose={3000} />
    </>
  );
};

// App entry point
function App() {
  return (
    <Router>
      <AppNav />
    </Router>
  );
}

export default App;
